var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Header'),_c('div',{staticClass:"content"},[_c('Logo',{attrs:{"subTitle":"Solicitar Renuncia al Fondo de Ahorro","description":""}}),_c('RenounceSaving')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }